// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","slogan":"Header_slogan__EXFhl","headerBtn":"Header_headerBtn__MdNPa","textBtn":"Header_textBtn__NsDHS"};